import React from "react";
import PropTypes from "prop-types";
import {
  MenuWrapper,
  MenuItem,
  CloseButton,
  CloseMenuWrapper,
} from "./Menu.styles";
import BootstrapIcon from "../BootstrapIcon/BoostrapIcon";

const Menu = ({ isMobile, items, onClose, ...restProps }) => {
  return (
    <MenuWrapper {...restProps}>
      {isMobile && (
        <CloseMenuWrapper>
          <CloseButton
            icon={<BootstrapIcon iconName="x-lg" />}
            type="text"
            shape="round"
            onClick={onClose}
          />
        </CloseMenuWrapper>
      )}
      {items?.map((item, index) => (
        <MenuItem key={index} {...item} />
      ))}
    </MenuWrapper>
  );
};

Menu.defaultProps = {
  isMobile: false,
  items: [],
};

Menu.propTypes = {
  isMobile: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({ ...MenuItem.propTypes })),
  onClose: PropTypes.func,
};

export default Menu;
